module.exports = __webpack_public_path__ + "static/history-stage-feb-2023-3c5826f9c8206e68d222db1c77aac1e1.jpeg";